module.exports = __webpack_public_path__ + "img/begin.e37065d6.svg";